import type { IAuthUser } from '@atlas/types'
import { apiClient } from './api.client'

// Atlas session establishment (ADR-0011 identity + ADR-0012 authorization). The Cognito OIDC user proves external
// identity; this call establishes the authoritative Atlas profile/role/active
// state. Role is NEVER read from Cognito claims — only from `/users/auth/me`. There is
// no session-bootstrap write endpoint and no browser-side user creation; the OIDC
// library owns login, callback, and session.
export const authService = {
	getCurrentUser: async (accessToken: string): Promise<IAuthUser> => {
		const response = await apiClient.get<IAuthUser>('/users/auth/me', {
			headers: { Authorization: `Bearer ${accessToken}` },
		})
		return response.data
	},
}
